import { render, staticRenderFns } from "./WhatHappensIfMyEtherWalletGoesDown.vue?vue&type=template&id=dec80cc8&scoped=true&"
import script from "./WhatHappensIfMyEtherWalletGoesDown.vue?vue&type=script&lang=js&"
export * from "./WhatHappensIfMyEtherWalletGoesDown.vue?vue&type=script&lang=js&"
import style0 from "./WhatHappensIfMyEtherWalletGoesDown.vue?vue&type=style&index=0&id=dec80cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec80cc8",
  null
  
)

export default component.exports